export async function reloadPageAction(): Promise<boolean> {
  window.location.reload();
  return false;
}
